export const FESTIVAL_OFFER_2026 = {
  id: 'festival-offer',
  title: 'Festival Booking + Family Membership Plan',
  subtitle: 'Extra Member Savings With Priority Service',
  description: 'One combined plan for festival bookings with membership benefits',
  detailedDescription: 'Join the Family Membership while booking your festival rituals to unlock extra discounts, priority pandit allocation, and faster support turnaround for the full season.',
  discount: 18,
  validUntil: '2026-12-31',
  validUntilFormatted: 'December 31, 2026',
  backgroundColor: 'from-purple-600 via-pink-600 to-red-500',
  icon: '🪔',
  features: [
    'Up to 18% combined savings on eligible services',
    'Priority morning and evening slots for members',
    'Priority pandit assignment in peak dates',
    'Material checklist shared after booking',
    'One free reschedule up to 48 hours before service',
    'Dedicated support queue for membership users',
    'Digital invoice and annual booking summary'
  ],
  includedServices: [
    'Shravan Somvar Pooja',
    'Navratri Pooja',
    'Dussehra Havan',
    'Diwali Lakshmi Pooja',
    'Govardhan Pooja',
    'Family Membership Benefits'
  ],
  originalPrice: 'Festival + Membership from ₹11,498',
  offerPrice: 'Bundle from ₹9,399',
  savings: 'Save up to ₹2,099 with combined plan',
  termsAndConditions: [
    'Valid for bookings confirmed by December 31, 2026',
    'Combined discount applies to listed festival services and eligible membership benefits',
    'Cannot be clubbed with referral credits',
    'Slots are subject to provider availability'
  ],
  urgency: 'Best Value Plan For Festival Season',
  cta: 'Join Plan & Book Now',
  secondaryCta: 'View Benefits'
};
